module.exports = __webpack_public_path__ + "media/images/domaine/domaine-defaut-20f033be7ba14c56da5673150b764e57.jpg";